<button mat-icon-button
[matMenuTriggerFor]="optionMoreMenu"
(click)="$event.stopPropagation();"
>
  <mat-icon
    data-cy="option-more-btn">
    more_vert
  </mat-icon>
</button>
<mat-menu #optionMoreMenu="matMenu" class="option-more-menu">
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="request-contract-menu-item"
    (click)="requestContract()"
    *ngIf="(option.status === 'draft') && canCreateContractRequest"
  >
    Request Contract
  </button>
  <button
    mat-menu-item
    class="option-more-menu disabled-item"
    data-cy="disabled-request-contract-menu-item"
    *ngIf="(option.status === 'draft') && !canCreateContractRequest"
  >
    Request Contract
  </button>
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="option-status-menu-item"
    *ngIf="!(option.status === 'draft')"
    [matMenuTriggerFor]="optionMoreSubMenu"
  >
    Option Status
  </button>
  <button mat-menu-item class="option-more-menu" (click)="openEditModal()">Edit</button>
  <button 
    mat-menu-item 
    *ngIf="(option.status === 'accepted' || option.status === 'contractRequested')"
    class="option-more-menu disabled-item" 
    data-cy="disabled-delete-menu-item"
  >
    Delete
  </button>
  <button 
    mat-menu-item 
    *ngIf="(option.status !== 'accepted' && option.status !== 'contractRequested')"
    class="option-more-menu" 
    data-cy="delete-menu-item"
    (click)="openDeleteConfirmationModal()"
  >
    Delete
  </button>
</mat-menu>
<mat-menu #optionMoreSubMenu="matMenu" class="option-more-menu">
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="accepted-menu-item"
    [ngClass]="{'checked-menu-item': option.status === 'accepted'}"
    (click)="changeStatus('accepted')"
  >
    Mark Option Accepted <mat-icon *ngIf="(option.status === 'accepted')" data-cy="accepted-checkmark-icon">check</mat-icon>
  </button>
  <button
    mat-menu-item
    class="option-more-menu"
    data-cy="declined-menu-item"
    [ngClass]="{'checked-menu-item': option.status === 'declined'}"
    (click)="changeStatus('declined')"
  >
    Mark Option Declined <mat-icon *ngIf="(option.status === 'declined')" data-cy="declined-checkmark-icon">check</mat-icon>
  </button>
</mat-menu>

<app-offer-option-edit-modal #offerOptionEditModal
  [optionParent]="getOptionParent(option)"
  [optionParentName]="optionParentName"
  [optionType]="optionType"
  [option]="option"
  (offerOptionUpdated)="handleOfferOptionUpdated($event)"
></app-offer-option-edit-modal>

<app-offer-option-delete-modal #offerOptionDeleteModal 
  [option]="option"
></app-offer-option-delete-modal>